import React from 'react'
import BSInputGroup from 'react-bootstrap/InputGroup'
import BSFormControl from 'react-bootstrap/FormControl';
import styled from 'styled-components';
import SearchIcon from '../../images/search.svg'
import { useLanguageState } from '../../globalStates/LanguageState';

const SearchFieldWrapper = styled.div`
    & > input-group {
        margin-bottom: 0;
    }
`

interface SearchFieldProps {
    onChange: (searchFilter: string) => void
}

const SearchField: React.FC<SearchFieldProps> = ({ onChange }) => {
    const branding = useLanguageState().getStrings()
    return (
        <SearchFieldWrapper>
            <BSInputGroup>
                <BSInputGroup.Text><img src={SearchIcon} alt="search" /></BSInputGroup.Text>
                <BSFormControl placeholder={branding.configuration.hntSearch} onChange={(event) => onChange(event.target.value)} />
            </BSInputGroup>
        </SearchFieldWrapper>
    )
}

export default SearchField